export default "__VITE_ASSET__CdR_xh5Z__"